import { _ as _asyncToGenerator, r as regenerator } from '../index-33ee6c9f.js';

// import createEmailEncoded from './crypto';
function extractUserInfo(_x) {
  return _extractUserInfo.apply(this, arguments);
}
function _extractUserInfo() {
  _extractUserInfo = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(data) {
    var _data$default_profile, default_profile_pic, _data$has_password, has_password, _data$is_activated, is_activated, _data$registered, registered, _data$account_type, account_type, subscription, _data$email, email, _data$photo, photo, _data$name, name, username, created, teams, key, id, is_verified, is_new, subscribed, isTrialUsed;
    return regenerator.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (data) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return", null);
        case 2:
          _data$default_profile = data.default_profile_pic, default_profile_pic = _data$default_profile === void 0 ? false : _data$default_profile, _data$has_password = data.has_password, has_password = _data$has_password === void 0 ? false : _data$has_password, _data$is_activated = data.is_activated, is_activated = _data$is_activated === void 0 ? false : _data$is_activated, _data$registered = data.registered, registered = _data$registered === void 0 ? false : _data$registered, _data$account_type = data.account_type, account_type = _data$account_type === void 0 ? '' : _data$account_type, subscription = data.subscription, _data$email = data.email, email = _data$email === void 0 ? '' : _data$email, _data$photo = data.photo, photo = _data$photo === void 0 ? '' : _data$photo, _data$name = data.name, name = _data$name === void 0 ? '' : _data$name, username = data.username, created = data.created, teams = data.teams, key = data.key, id = data.id, is_verified = data.is_verified; // const email_encoded = await createEmailEncoded(email);
          is_new = registered;
          subscribed = subscription && subscription.granted;
          isTrialUsed = subscription ? !!subscription.is_trial_used : false;
          return _context.abrupt("return", {
            default_profile_pic: default_profile_pic,
            has_password: has_password,
            // email_encoded,
            account_type: account_type,
            is_activated: is_activated,
            isTrialUsed: isTrialUsed,
            subscribed: subscribed,
            username: username,
            created: created,
            is_new: is_new,
            photo: photo,
            email: email,
            teams: teams,
            name: name,
            key: key,
            id: id,
            is_verified: is_verified
          });
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _extractUserInfo.apply(this, arguments);
}

export { extractUserInfo as default };
//# sourceMappingURL=index.js.map
